export default __webpack_public_path__ + "static/iphonex-174cf24fbb552049b4dc4ecab4005bac.png";